module.exports = __webpack_public_path__ + "static/media/doctor-doing-a-medical-exam.49da4b81.jpg";